import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { LANDING } from "@/constants/testIds";
import { CONTACT } from "@/lib/siteData";

export const FinalCTA = () => {
  return (
    <section className="relative py-12 lg:py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[2.5rem] bg-slate-900 overflow-hidden p-10 sm:p-16 lg:p-24"
        >
          {/* Decorative orbs */}
          <div className="absolute -top-32 -right-32 w-96 h-96 bg-cyan-500/25 rounded-full blur-3xl" />
          <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-sky-500/20 rounded-full blur-3xl" />
          <div className="absolute inset-0 opacity-[0.04]" style={{
            backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.6) 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }} />

          <div className="relative max-w-3xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400">Ready When You Are</span>
            <h2
              className="font-display mt-4 text-3xl sm:text-5xl lg:text-6xl font-bold text-white leading-[1.05]"
              data-testid="final-cta-tagline"
            >
              Don&apos;t guess what&apos;s
              <br />
              in your water. Be <span className="text-cyan-400">AWARE</span>.
            </h2>
            <p className="mt-5 text-lg text-slate-300 max-w-xl">
              Book online in under 90 seconds. Lab analysis, plain-English summary, and practical recommendations — delivered.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-3">
              <Link
                to="/book-water-test"
                data-testid={LANDING.finalCtaBtn}
                className="btn-aqua group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base font-semibold"
              >
                Book a Water Test
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              <a
                href={CONTACT.phoneLink}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-base font-semibold text-white border-2 border-white/20 hover:border-white/50 hover:bg-white/5 transition-all"
              >
                <Phone className="w-4 h-4" />
                {CONTACT.phone}
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
